import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment, Form, Button, Popup } from "semantic-ui-react";
import BdodJobList from "./BdodJobList";
import { observer } from "mobx-react-lite";
import BdodJobStore from "../../../app/stores/bdodjobsStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";

const BdodJobDashboard: React.FC = () => {
  const bdodjobStore = useContext(BdodJobStore);
  const {
    submitting,
    loadBdodJobTechs,
    searchBdodJobs,
    bdodjobTech,
    bdodjobsByDate,
  } = bdodjobStore;

  useEffect(() => {
    loadBdodJobTechs();
  }, []);

  const [search, setSearch] = useState({
    tech: "",
    status: "",
    jobStartDate: "",
    jobEndDate: "",
    workNo: "",
  });

  if (bdodjobStore.loadingInitial)
    return <LoadingComponent content="Loading BdodJobs" />;

  const techOptions = bdodjobTech.map(function (tech) {
    var option = { key: tech.tech, text: tech.tech, value: tech.tech };
    return option;
  });
  const statusOptions = [
    { key: "Complete", text: "Complete", value: "Complete" },
    { key: "In Progress", text: "In Progress", value: "In Progress" },
    { key: "New Job", text: "New Job", value: "New Job" },
  ];

  const handleSubmit = () => {
      searchBdodJobs(search);
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setSearch({ ...search, [name]: value });
  };

  return (
    <Segment>

          <Form onSubmit={handleSubmit}>
          <Grid>
          <Grid.Column width={3}>
            <Form.Select
              label="Tech"
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={techOptions}
              search
              name="tech"
              placeholder="Tech"
              value={search.tech}
              clearable
              width={3}
            />
            </Grid.Column>
            <Grid.Column width={2}>

            </Grid.Column>
            <Grid.Column width={3}>
              <Form.Select
              label="Status"
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={statusOptions}
              search
              name="status"
              placeholder="Status"
              value={search.status}
              clearable
            />
           </Grid.Column>
            </Grid>
            <Grid>
            <Grid.Column width={3}>
            <Form.Input
          label='Job Start Date'
          onChange={handleInputChange}
          name='jobStartDate'
          type='date'
          placeholder='Date'
          clearable
          value={search.jobStartDate}
        />
           </Grid.Column>
           <Grid.Column width={3}>
            <Form.Input
          label='Job End Date'
          onChange={handleInputChange}
          name='jobEndDate'
          type='date'
          placeholder='Date'
          clearable
          value={search.jobEndDate}
        />
           </Grid.Column>
            </Grid>
            <Grid>
            <Grid.Column width={3}>
            <Form.Input
          label='Work No.'
          onChange={handleInputChange}
          name='workNo'
          placeholder='Work No.'
          value={search.workNo}
        />
        </Grid.Column>
        </Grid>
             <br/>
            <Button
              loading={submitting}
              floated="left"
              positive
              type="submit"
              content="Search"
            />
          </Form>
          

      <Grid> 
      <Grid.Column width={13}>
      <CSVLink data={bdodjobsByDate}  filename={"bdodlist.csv"}>
      <Popup content='Download as CSV' trigger={<Button icon='download' floated='left' />} />
      </CSVLink>
      </Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            as={Link}
            to={`/financemanagement/bdodjob-create`}
            color="linkedin"
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <BdodJobList />
        </Grid.Column>
      </Grid>
    </Segment>
  );

};

export default observer(BdodJobDashboard);
